var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5575 8.81766C22.4593 8.80172 22.3599 8.79437 22.2604 8.79566H5.32893L5.69812 8.62394C6.059 8.45314 6.38731 8.22067 6.66833 7.93707L11.4164 3.18904C12.0417 2.59211 12.1468 1.63182 11.6653 0.91377C11.1051 0.148602 10.0306 -0.0175353 9.26537 0.542751C9.20355 0.588042 9.14479 0.637411 9.08957 0.690536L0.503632 9.27647C-0.167358 9.94671 -0.167949 11.034 0.502291 11.705C0.50272 11.7054 0.503203 11.7059 0.503632 11.7063L9.08957 20.2922C9.7611 20.9619 10.8483 20.9604 11.518 20.2888C11.5707 20.236 11.62 20.1798 11.6653 20.1205C12.1468 19.4025 12.0417 18.4422 11.4164 17.8452L6.67692 13.0886C6.42498 12.8364 6.13531 12.6249 5.81833 12.4619L5.30317 12.23H22.1659C23.0432 12.2626 23.8128 11.6498 23.9776 10.7876C24.1294 9.85146 23.4936 8.96953 22.5575 8.81766Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.bc83947eca2299a2ec16f5215f7f006c.svg";
export { ForwardRef as ReactComponent };